export const kPaymentDetailsCacheDuration = 1000 * 60 * 60 // 1 hour
export const kSessionStorageSubscriptionNoticeBannerDismissedKey = 'subscriptionNoticeBannerDismissed'
